module.exports = __webpack_public_path__ + "static/media/IMG_2722.1ec86512.JPG";